import { h } from 'preact'
import { UserData } from '../Event/EventAttendees'
import UserAvatar from '../User/UserAvatar'
import Phrase from '../../libs/translationsUtils/phrase'

interface Props {
  members: UserData[],
  memberCount: number,
  visibleMemberCount?: number
}

// the value of visibleMemberCount should optimally be divisible by 10
const GroupMembers = ({ members, memberCount, visibleMemberCount = 30 }: Props) => {
  const visibleMembers = members.slice(0, visibleMemberCount)

  return (
    <div className='widget group-content-container-members'>
      <h3 className='widget-title'><Phrase p='Members' /></h3>
      <div className='group-content-container-members_member-list'>
        {
          visibleMembers.map((member, index) => (
            <div key={index} className='group-content-container-members_member-list_list-item-outer'>
              <div className='group-content-container-members_member-list_list-item-inner'>
                <UserAvatar
                  key={member.id}
                  user={member}
                  extraClass='thread-list-avatar avatar--fill-parent'
                  showRank
                  optimizeAvatarResolution
                />
              </div>
            </div>
          )
          )
        }
      </div>
      {
        memberCount > visibleMemberCount && (
          <div className='group-content-container-members_additional-member-count'>
            + {memberCount - visibleMemberCount}
          </div>
        )
      }
    </div>
  )
}

export default GroupMembers
